import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=54712052"
import script from "./OrganisationSettings.vue?vue&type=script&lang=js"
export * from "./OrganisationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54712052')) {
      api.createRecord('54712052', component.options)
    } else {
      api.reload('54712052', component.options)
    }
    module.hot.accept("./OrganisationSettings.vue?vue&type=template&id=54712052", function () {
      api.rerender('54712052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Organisation/OrganisationSettings.vue"
export default component.exports